export const PipelineStatus = {
  ACTIVE: 1,
  ARCHIVED: 0
};

export const PipelineStatusOptions = [
  { value: PipelineStatus.ARCHIVED, label: 'Archived', mode: 'disabled' },
  { value: PipelineStatus.ACTIVE, label: 'Active', mode: 'success' }
];

/**
 * Stage-list API version used by the deal screen and task forms.
 *
 * The unversioned / 2022-12-23 endpoint is the board summary: it runs the
 * per-column task-count and revenue aggregates and prepends the synthetic
 * Inactive/Dormant stages. Nothing outside the pipeline board needs any of
 * that, so these screens ask for the plain stage list instead.
 *
 * Keep this in the query key. Consumers that legitimately need the board
 * summary share the bare ['pipelineStages', id] key, and in TanStack Query the
 * first observer to mount supplies the queryFn for everything on that key.
 */
export const PIPELINE_STAGES_LIST_API_VERSION = '2025-11-03';
